export const TestimonyData = [
    {
        id:1,
        name:"Malhub CEO",
        content:"Having you on the team makes a huge differrent."
    },
    {
        id:2,
        name:"Sir Heritage",
        content:"You are just like they describe you, Thank you for getting Our work done."
    },
    {
        id:3,
        name:"Amam store",
        content:"You always find a way to get it done - and you done it well."
    },
    {
        id:4,
        name:"Sulyman kamaldeen",
        content:"I really appereciate your team-work and talent."
    }
]